// import React, { useState } from "react";
// import "../App.css";

// const levels = ["Bronze", "Silver", "Gold", "Platinum"];
// const maxProgress = 4000;

// const ArrowStructure = () => {
//   const [progress, setProgress] = useState(0);

//   const updateProgress = (value) => {
//     setProgress((prev) => Math.min(prev + value, maxProgress));
//   };

//   return (
//     <div className="container">
//       <div className="progress-container">
//         <div className="steps">
//           {levels.map((level, index) => (
//             <div
//               key={index}
//               className={`step ${progress >= (index / (levels.length - 1)) * maxProgress ? "active" : ""}`}
//             >
//               <div className="step-circle">{progress >= (index / (levels.length - 1)) * maxProgress ? "✔" : "✔"}</div>
//               <span className="step-label">{level}</span>
//             </div>
//           ))}
//         </div>
//         <div className="progress-bar-container">
//           <div className="progress-bar">
//             <div className="progress" style={{ width: `${(progress / maxProgress) * 100}%` }}></div>
//           </div>
//         </div>
//         <div className="progress-info">
//           <span>{progress} / {maxProgress}</span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ArrowStructure;

// TierFlow.js
import React from "react";

const TierFlow = ({ tiers, currentTierId, currentPoints, maxPoints }) => {
  const styles = {
    tierFlow: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      position: "relative",
      width: "100%",
      margin: "20px 0",
    },
    tierStep: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      flex: 1,
      textAlign: "center",
    },
    tierCircle: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      border: "2px solid #ccc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#ccc",
      color: "#fff",
      fontWeight: "bold",
      zIndex: 2,
    },
    tierCircleActive: {
      background: "#28a745",
      borderColor: "#28a745",
    },
    tierCircleCompleted: {
      background: "#28a745",
      borderColor: "#28a745",
    },
    tierName: {
      marginTop: "8px",
      fontSize: "14px",
      fontWeight: "500",
    },
    tierLine: {
      position: "absolute",
      top: "20px",
      left: "50%",
      width: "100%",
      height: "2px",
      background: "#ccc",
      zIndex: 1,
    },
    tierLineActive: {
      background: "#28a745",
    },
    tierPoints: {
      position: "absolute",
      top: "-30px",
      background: "#28a745",
      color: "#fff",
      padding: "4px 8px",
      borderRadius: "12px",
      fontSize: "12px",
      whiteSpace: "nowrap",
    },
  };

  return (
    <div style={styles.tierFlow}>
      {tiers.map((tier, index) => {
        const isActive = tier.tierId === currentTierId;
        const isCompleted = tier.tierId < currentTierId;
        return (
          <div key={tier.tierId} style={styles.tierStep}>
            {isActive && (
              <div style={styles.tierPoints}>
                {currentPoints}/{maxPoints}
              </div>
            )}
            <div
              style={{
                ...styles.tierCircle,
                ...(isActive ? styles.tierCircleActive : {}),
                ...(isCompleted ? styles.tierCircleCompleted : {}),
              }}
            >
              ✓
            </div>
            <div style={styles.tierName}>{tier.tier_name}</div>
            {index < tiers.length - 1 && (
              <div
                style={{
                  ...styles.tierLine,
                  ...(isActive || isCompleted ? styles.tierLineActive : {}),
                }}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TierFlow;

